export default "__VITE_ASSET__BJg3gZBe__"